import safeLog from '@alife/bc-safe-log';

function logError(err) {
  err && safeLog('/sc.details.error', 'OTHER', `scene=detailTab&msg=${err.stack || err}`);
}

function logDeprecate(msg) {
  msg && safeLog('/sc.details.deprecate', 'OTHER', `scene=detailTab&msg=${msg}`);
}

export {
  logError,
  logDeprecate,
};
